import template from './employees_future_leave_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportFutureLeaveViewModel
{
	constructor(page)
	{
		this.page = page;

		this.employee_current_leave_list = ko.observableArray();
		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();
		this.loader = ko.observable(false);

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeLeaveComingUpHelp', { employee_id: this.page.bindings.id });
	}
}

class ReportFutureLeavePage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportFutureLeaveViewModel(this);
		window.current_page_title(tr('Upcoming Employee Leave'));
	}

	async updateData()
	{
		this.viewModel.loader(true);

		//This is to set the href so that the page goes to Calendar if an employee is not a subordinate of the current logged in. 
		let managers_data = await Grape.fetches.getJSON('/api/record', { schema: 'savanna', table: 'v_employees_manager', limit: 1000000 });

		let managers = [];

		if (typeof managers_data === 'undefined'){}
		else
			managers = managers_data.records;

		let employee_id = Utils.get_local_storage_nullable('employee_id');
		
		//Get list of employees managed by logged in employee
		let subs = [];
		//Check if current employee manages 
		for (let k = 0; k < managers.length; k++)
		{
			if (employee_id == managers[k].manager_employee_id)
				subs.push(managers[k].subordinate_employee_id);
		}

		let data = { department_id: this.viewModel.current_department_id() };
		let res = await Grape.fetches.postJSON('/general/future_leave_list', data);

		if (typeof res === 'undefined' || !res.length)
			this.viewModel.employee_current_leave_list([]);
		else
		{
			for (let i = 0; i < res.length; i++)
			{
				res[i].fullName = res[i].firstname + ' ' + res[i].surname;
				res[i].link = '/#/general/calendar';

				if (subs.includes(res[i].employee_id) || Grape.currentSession.roles.includes("admin"))
					res[i].link = '/#/employee/view/' + res[i].employee_id;
			}
			this.viewModel.employee_current_leave_list(res);
		}
		this.viewModel.loader(false);
	};

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeLeaveComingUpReport'))
			return;

		document.title = tr('Upcoming Employee Leave');
	}
}

export default {
	route: '[/]general/future_leave_report',
	page_class: ReportFutureLeavePage,
	template: template,
	template_filename: 'translation/employees_future_leave_report'
};
